module.exports = {
  StartEndDateCannotEmpty: 'Дата начала или дата окончания не могут быть пустыми!',
  StartBeEarlierThanDate: 'Дата начала должна быть меньше даты окончания!',
  Continent: 'Континент',
  Route: 'Маршрут',
  Network: 'Сеть',
  Currency: 'Валюта',
  ContainerType: 'Тип контейнера',
  Package: 'Упаковка',
  BillOfLadingType: 'Тип коносамента',
  CargoType: 'Тип груза',
  TradeTerms: 'Торговые условия',
  TransportationTerms: 'Транспортные условия',
  FreightTerms: 'Условия фрахта',
  TradeMethod: 'Способ торговли',
  CustomsDeclarationMethod: 'Способ таможенного оформления',
  AirFreightServiceItem: 'Услуги авиаперевозки',
  RelatedPort: 'Связанные порты',
  AirWaybillSundryCharge: 'Дополнительные сборы авианакладной',
  ClientType: 'Тип клиента',
  AppraisalCategory: 'Тип экспертизы',
  ShippingDocumentMethod: 'Способ коносамента',
  CustomBusinessType: 'Пользовательский тип бизнеса',
  TransitDocumentType: 'Тип документооборота',
  CommissionRule: 'Правила комиссионных',
  RailwayLine: 'Железнодорожный маршрут',
  ValueAddedService: 'Доп. усл.',
  BilledUnitUnit: 'Единица тарификации/Единица',
  HazardousGoods: 'Опасные грузы',
  CargoInformation: 'Информация о грузе',
  LiabilityReason: 'Причина определения ответственности',
  ClientSource: 'Источник клиента',
  MultimodalTransportType: 'Тип комбинированной перевозки',
  VehicleType: 'Тип автомобиля',
  CustomEqType: 'Пользовательский тип контейнера',
  CollaborativeBusinessType: 'Тип совместного бизнеса',
  Records: 'шт.;',
  recordsImportedToTheSystem: '@records успешно импортированы в систему!',
  Records2: 'шт.',
  Edit: 'Редактировать',
  Delete: 'Удалить',
  Disable: 'Отключить',
  Enable: 'Включить',
  AreWantToDeleteRecord: 'Вы уверены, что хотите удалить эту запись?',
  Reminder: 'Подсказка',
  Confirm: 'Подтвердить',
  Cancel: 'Отмена',
  SuccessfullyDeleted: 'Удаление успешно!',
  DeletionCanceled: 'Удаление отменено',
  DoToOverwriteExistingData: 'Перезаписать существующие данные?',
  Overwrite: 'Перезаписать',
  PleaseSelectDataToExport: 'Пожалуйста, выберите данные для экспорта.',
  UploadedBeXlsOrFormat: 'Загружаемый файл должен быть в формате xls или xlsx!',
  FileSizeCannotExceed2MB: 'Размер файла не должен превышать 2 МБ.',
  ImportPleaseContactTheAdministrator: 'Ошибка импорта. Пожалуйста, свяжитесь с администратором.',
  DataExistingDataInTable: 'Данные дублируют существующие данные в таблице!',
  SuccessfullyAdded: 'Успешно добавлено.',
  City: 'Город',
  BusinessType: 'Тип операции',
  PlatformCustomerService: 'Служба поддержки платформы',
  Code: 'Код',
  Name: 'Название',
  ChineseName: 'Китайское название',
  EnglishName: 'Английское название',
  ChineseName2: 'Китайское наименование',
  FeeDetailsXls: 'Детализация расходов.xls',
  UnitedNationsNumberAlreadyExists: 'Номер ООН уже существует.',
  UserCannotBeEmpty: 'Пользователь не может быть пустым.',
  Yes: 'Да',
  No: 'Нет',
  MergeInProgressPleaseWait: 'Идет объединение, пожалуйста, подождите.',
  YouExpectedToCompleteLater: 'Вы можете покинуть этот интерфейс. Объединение завершится в течение 10 минут. Проверьте позже.',
  Note: 'Подсказка',
  Success: 'Операция выполнена успешно.',
  ChineseNameCannotBeEmpty: 'Китайское название не может быть пустым.',
  EmailFormatError: 'Неверный формат email.',
  ApplicableOrderRulescombinedName: 'Название правила выпуска (комбинация)',
  OnlyCanBeSetPort: 'Для одного порта назначения можно установить только одного агента по умолчанию.',
  UserCannotBeEmpty2: 'Пользователь не может быть пустым!',
  DataIsIncorrectPleaseCheck: 'Неверные данные, пожалуйста, проверьте!',
  PleaseNumberYouWantDelete: 'Пожалуйста, выберите номер договора для удаления!',
  PleaseSelectABranch: 'Пожалуйста, выберите филиал!',
  SiteNotSelected: 'Сайт не выбран.',
  AlreadyAddedCannotAddRepeatedly: 'Уже добавлено, повторное добавление невозможно!',
  AddedSuccessfully: 'Успешно добавлено.',
  SavedLibraryAlreadyExistsSave: 'Сохранено успешно. Следующие стоп-слова уже существуют и не требуют сохранения:',
  SavedWordsHaveBeenTimes: 'Сохранено успешно. Следующие стоп-слова были введены несколько раз:',
  TheHaveBeenEnteredTimes: 'Следующие стоп-слова были введены несколько раз:',
  FieldName: 'Название поля',
  SensitiveWords: 'Стоп-слово',
  Threshold: 'Порог стоп-слова',
  ThresholdTip: 'Порог стоп-слова указывает на количество нечетких символов. 0 означает 100% совпадение.',
  EditedSuccessfully: 'Редактирование успешно.',
  ChineseProductName: 'Китайское наименование товара',
  EnglishProductName: 'Английское наименование товара',
  ShippingMarks: 'Маркировка',
  EmailRemindertestOnly: 'Email-уведомление (для тестирования)',
  SplitDataBecomesNewData: 'Разделение (старые данные становятся новыми)',
  SplittingDataAreYouSplit: 'После разделения исходные данные будут удалены. Подтверждаете разделение?',
  SplitSuccessfullySplitInto: 'Разделение успешно, разделено на',
  SensitiveWordManagement: 'Управление стоп-словами',
  CodeCannotBeEmpty: 'Код не может быть пустым.',
  EnglishNameCannotBeEmpty: 'Английское название не может быть пустым.',
  ContractConfiguration: 'Конфигурация контракта',
  NoteTheReminderMethodIs: 'Примечание: Способ напоминания -',
  ReminderConfiguration: 'Настройка напоминаний:',
  ReminderRemaining: 'Осталось до даты истечения',
  DaysBeforeTheDueDate: 'дней напоминание',
  ReminderUser: 'Уведомить пользователей:',
  ContractAdministrator: 'Администратор контракта',
  Sales: 'Продажи',
  ProhibitionOfCreatingBusinessConfiguration: 'Запрещено создавать бизнес-конфигурации:',
  ContractAbleToCreateExpiration: 'После истечения срока действия контракта создание бизнеса будет невозможно',
  SavedSuccessfully: 'Сохранено успешно',
  CustomerLevel: 'Уровень клиента',
  ContractStatus: 'Статус контракта',
  ContractType: 'Тип контракта',
  ExtensionCycle: 'Период продления',
  Partner: 'Партнер',
  ContractNumber: 'Номер контракта',
  EffectiveDate: 'Дата вступления в силу',
  ExpirationDate: 'Дата истечения',
  ContractAgreement: 'Договор контракта',
  CustomerContract: 'Клиентский контракт',
  SupplierContract: 'Контракт с поставщиком',
  OverseasAgentContract: 'Контракт с зарубежным агентом',
  OtherContracts: 'Другие контракты',
  ContractTerms: 'Условия контракта',
  DeferredAfterExpiration: 'Автопродление после истечения',
  N1Year: '1 год',
  N2Years: '2 года',
  N3Years: '3 года',
  Other: 'Другое',
  OneClickRenewal: 'Продлить одним кликом',
  Close: 'Закрыть',
  AddContract: 'Добавить контракт',
  EditContract: 'Редактировать контракт',
  RenewContract: 'Продлить контракт',
  ViewContract: 'Просмотреть контракт',
  Contract: 'Контракт',
  PartnerCannotBeEmpty: 'Партнер не может быть пустым.',
  ContractNumberCannotBeEmpty: 'Номер контракта не может быть пустым.',
  EffectiveDateCannotBeEmpty: 'Дата вступления в силу не может быть пустой.',
  ExpirationDateCannotBeEmpty: 'Дата истечения не может быть пустой.',
  ContractAgreementCannotBeEmpty: 'Договор контракта не может быть пустым.',
  unSupportContractCurrency: 'Не удалось найти прямой или косвенный курс обмена "{0}" на "{1}". Пожалуйста, своевременно обновите соответствующие курсы.',
  QuickSearchContractNumber: 'Быстрый поиск: Номер контракта',
  LogRecord: 'Журнал записей',
  Add: 'Добавить',
  HintSetToExpireDays: 'Подсказка: Система установит как приближающийся срок в течение 30 дней',
  OperationType: 'Тип операции',
  Operator: 'Оператор',
  Time: 'Время',
  EditField: 'Редактируемое поле',
  OriginalValue: 'Исходное значение',
  NewValue: 'Новое значение',
  AuditStatus: 'Статус проверки',
  OperationDate: 'Дата операции',
  SettlementType: 'Тип расчёта',
  SettlementMethod: 'Способ расчёта',
  Limit: 'Лимит',
  LimitCurrency: 'Валюта лимита',
  DateType: 'Тип даты',
  BillingCycle: 'Период учёта',
  WhetherToPostpone: 'Переносить ли срок',
  PostponementCycle: 'Период переноса',
  WhetherChapterHasBeenUploaded: 'Загружена ли бронь',
  WhetherAgreementHasBeenUploaded: 'Загружено ли договорное соглашение',
  Operation: 'Действие',
  Renewal: 'Продление',
  Revoke: 'Отмена',
  TheAndTheOperationAllowed: 'Договор продлён, операции запрещены',
  DoYouNeedToUpdate: 'Требуется ли обновление',
  ContractCreator: 'Создатель договора',
  ContractCreationTime: 'Время создания договора',
  PartnerCreator: 'Создатель партнёра',
  ContractAuditor: 'Проверяющий договора',
  ContractAuditTime: 'Время проверки договора',
  PleaseSelectContractRecord: 'Выберите запись договора.',
  ContractRecordIsEmpty: 'Записи договоров отсутствуют.',
  ContractRevocationSuccessful: 'Договор успешно отменён.',
  QuickSearch: 'Быстрый поиск:',
  BulkRejection: 'Массовый отказ',
  All: 'Все',
  Unaudited: 'Не проверено',
  Submitted: 'Отправлено',
  Audited: 'Проверено',
  PleaseSelectData: 'Отметьте данные.',
  OnlySchemesWithAuditUnreviewed: 'Можно выбрать только тарифные планы со статусом "Не отправлено".',
  OnlySchemesWithAuditReviewed: 'Можно выбрать только тарифные планы со статусом "Проверено".',
  OnlySchemesWithAuditSubmitted: 'Можно выбрать только тарифные планы со статусом "Отправлено".',
  OnlyGuaranteeWithAuditUnreviewed: 'Можно выбрать только гарантии со статусом "Не отправлено".',
  OnlyGuaranteeWithAuditReviewed: 'Можно выбрать только гарантии со статусом "Проверено".',
  OnlyGuaranteeWithAuditSubmitted: 'Можно выбрать только гарантии со статусом "Отправлено".',
  GuaranteeFileIsNull: 'Файлы гарантий отсутствуют',
  SelectGuaranteeFileIsNull: '{0} не загрузил файл гарантии',
  CodeDuplicatedPleaseReEnter: 'Код повторяется, введите заново.',
  Country: 'Страна',
  CannotEditMultipleSchemes: 'Нельзя редактировать несколько планов.',
  CannotCopyMultipleSchemes: 'Нельзя копировать несколько планов.',
  DeletedSuccessfully: 'Успешно удалено',
  PleaseEnterTheSchemeName: 'Введите название схемы',
  PleaseEnterTheStartingRow: 'Введите начальную строку',
  PleaseTheExcelCellName: 'Укажите название ячейки Excel',
  PleaseEnterTheSpaceProportion: 'Введите процентное содержание пробелов',
  EnglishName2: 'Английское название',
  UnknownType: 'Тип неизвестен',
  SeaExport: 'Морской экспорт',
  AirExport: 'Авиационный экспорт',
  BusinessTypeCannotBeEmpty: 'Тип операции не может быть пустым.',
  OperationTypeCannotBeEmpty: 'Тип требований к операции не может быть пустым.',
  ContentDescriptionCannotBeEmpty: 'Описание содержимого не может быть пустым.',
  OverseasWarehouse: 'Зарубежный склад',
  PartnerInformationImport: 'Импорт информации о партнерах',
  PleaseSelectTemplateType: 'Выберите тип шаблона',
  PleaseSelectImportType: 'Выберите тип импорта',
  ImportTime: 'Время импорта',
  SelectDate: 'Выберите дату',
  ImportResult: 'Результат импорта',
  PleaseSelect: 'Выберите',
  ImportType: 'Тип импорта',
  ImportSuccessful: 'Импорт успешно завершен',
  DownloadTemplate: 'Скачать шаблон',
  PartnerBasicInformation: 'Основная информация о партнере',
  PartnerBillingHeaderInformation: 'Реквизиты для выставления счета партнера',
  Download: 'Скачать',
  ImportFile: 'Импортировать файл',
  SelectFile: 'Выбрать файл',
  ConfirmImport: 'Подтвердить импорт',
  ReminderPartnerBasicInformationFirst: 'Напоминание: сначала импортируйте основную информацию о партнере',
  Search: 'Поиск',
  To: 'до',
  ContinueImport: 'Продолжить импорт',
  EnterPartnerInformation: 'Перейти к партнеру',
  DownloadImportResult: 'Скачать результат импорта',
  ViewFile: 'Просмотреть файл',
  SerialNumber: 'Серийный номер',
  LogFile: 'Файл журнала',
  RemarkDescription: 'Примечание',
  AllSuccessful: 'Все успешно',
  AllFailed: 'Все неудачно',
  PartiallySuccessfulPartiallyFailed: 'Частично успешно, частично неудачно',
  TheOnlyBeXlsFormat: 'Загружаемый файл должен быть в формате xls или xlsx!',
  ConfirmDeletionOfTheSite: 'Подтвердить удаление станции?',
  TheByTheBusinessDeleted: 'Следующие станции используются в бизнесе, удаление запрещено!',
  RailwayStation: 'Железнодорожная станция',
  WhetherToOverwriteExistingData: 'Перезаписать существующие данные?',
  PleaseDataYouWantExport: 'Выберите данные для экспорта.',
  FileBeLargerThan2MB: 'Размер файла не должен превышать 2 МБ',
  Items: 'шт.;',
  recordsImportedIntoTheSystem: '@records записей успешно импортированы в систему!',
  Items2: 'Пункт',
  PortOfLoadingPOL: 'Порт отпр.(POL)',
  PortOfDischargePOD: 'Порт выгрузки (POD)',
  PlaceOfDelivery: 'Место доставки',
  ShippingCompany: 'Судоходная компания',
  DestinationPortAgent: 'Агент в порту назначения',
  ShippingRoute: 'Маршрут',
  DisplayRules: 'Правила отображения',
  OperationalRequirements: 'Требования к операции',
  PleaseEnterTheContent: 'Введите содержание',
  AttachmentDescription: 'Описание вложения',
  ViewAttachment: 'Просмотреть вложение',
  WhetherToUseForMBL: 'Использовать для MBL',
  WhetherToUseForHBL: 'Использовать для HBL',
  AddPortRequirementsseaPort: 'Добавить требования к порту (морской порт)',
  PleaseARecordForEditing: 'Выберите запись для редактирования',
  EditPortRequirementsseaPort: 'Редактировать требования к порту (морской порт)',
  PleaseARecordForDeletion: 'Выберите запись для удаления',
  WhetherDeleteTheSelectedRecords: 'Удалить выбранную запись?',
  Notice: 'Подсказка',
  DeletionCancelled: 'Удаление отменено',
  DeletionFailed: 'Не удалось удалить!',
  DisplayRulesAreRequired: 'Правила отображения обязательны!',
  OperationalRequirementsAreRequired: 'Требования к операции обязательны!',
  SuccessfullyAddedPortRequirements: 'Требования к порту успешно добавлены',
  SuccessfullyModifiedPortRequirements: 'Требования к порту успешно изменены',
  MarksAndNumbers: 'Маркировка',
  IMDGCODEImport: 'Импорт IMDG CODE',
  PleaseUploadTxtFormatFile: 'Загрузите файл в формате txt!',
  SuccessfullyImported: 'Успешно импортировано',
  Items3: 'Записей',
  DangerousGoodsList: 'Список опасных грузов',
  NoteSystemReminder: 'Примечание: Способ напоминания - "системное напоминание", система напомнит за 2 дня до срока.',
  CustomerSignedRenewal: 'Клиент уже подписал {0}, можно выбрать его для продления!',
  DuplicateBaseCurrencyValueExcel: 'Значение исходной валюты \'{0}\', значение базовой валюты \'{1}\' дублируется с другими данными в Excel!',
  DuplicateCurrencyValue0Table: 'Значение исходной валюты \'{0}\', значение базовой валюты \'{1}\' дублируется с существующими данными в таблице!',
  DoOfThe00: 'Подтверждаете отмену контракта \'{1}\' с \'{0}\'?',
  UploadPiecesUploadFailedPieces: 'Успешно загружено: {0}, не удалось загрузить: {1}.',
  DoWantToDelete0: 'Подтверждаете удаление 【{0}】?',
  TheValueIs0Excel: 'Значение исходной валюты \'{0}\', значение базовой валюты \'{1}\' дублируется с другими данными в Excel!',
  TheIs0WhichTable: 'Значение исходной валюты \'{0}\', значение базовой валюты \'{1}\' дублируется с существующими данными в таблице!',
  ChargeGroup: 'Группа расходов',
  DefaultWhtRate: 'Ставка WHT по умолчанию',
  ApplicableWhtTax: 'Применяется WHT',
  ApplicableWhtTaxTip: 'Применяется для функции возврата налога WHT (налог у источника) в Таиланде, требуется включить функцию в настройках филиала.',
  ExchangeRateDecimalPlaces: 'Десятичные знаки курса',
  SeaAirRoutes: 'Морской/авиа маршрут',
  AppliedSeaport: 'Применить морской порт',
  AppliedShippingCompany: 'Применить судоходную компанию',
  ApplicationAirport: 'Применить аэропорт',
  AppliedAirlines: 'Прикладная авиакомпания',
  VerificationItem: 'Проверочный пункт',
  SensitiveWordExists: 'База чувствительных слов уже существует',
  ClearCreditExpiration: 'Очистить кредитный контроль после истечения срока',
  SubordinateCompanyPartners: 'Партнеры дочерней компании',
  GpExplainTitle: 'Заголовок пояснения GP',
  UncheckArApMate: 'Не участвует в проверке соответствия AR/AP',
  UncheckArApMateTip: 'После отметки данный расход не участвует в проверке "дебиторская задолженность включает кредиторскую"',
  ExistCustomerVendorException: 'Клиент-поставщик с таким же названием и кодом уже существует, сохранение успешно',
  ExistCustomerCodeExcepiton: 'Клиент с таким же названием и кодом уже существует, сохранение успешно',
  ExistVendorCodeException: 'Поставщик с таким же названием и кодом уже существует, сохранение успешно',
  SyncCustomerCodeExcepiton: 'Ошибка синхронизации кода клиента, код клиента очищен',
  SyncVendorCodeException: 'Ошибка синхронизации кода поставщика, код поставщика очищен',
  mailing: 'Отправка-получение (коммуникация)',
  SyncCustomerVendorException: 'Ошибка синхронизации кодов клиента и поставщика, коды очищены',
  b2bWebsiteDisplayNotEmpty: 'Отображение на B2B-сайте не может быть пустым',
  IsItManualLaborCost: 'Ручной ли это расход',
  FreeOfArCharge: 'Без взимания',
  FreeOfApCharge: 'Без оплаты',
  MergeAndDisplayToDesignatedFees: 'Объединенное отображение в указанный расход',
  MergeAndDisplayTips: 'На текущем этапе арендатор поддерживает объединенное отображение только одной группы расходов.',
  MergeAndDisplayToDesignatedFeesTips: 'Для модулей запроса продаж и удаленного бронирования кредиторские расходы объединяются под указанным названием. Пока поддерживается настройка только одной группы объединенных расходов.',
  operationTip: 'Данная операция необратима после подтверждения!!!!',
  MscService: 'Код услуги Msc',
  PropulsionType: 'Тип двигателя',
  AircraftModel: 'Тип самолёта',
  UnitLoadDevice: 'Единица загрузки'
}
